  import { Component, OnInit, ChangeDetectionStrategy, ViewChild, TemplateRef ,
    ViewEncapsulation, NgZone} from '@angular/core';
  import { DoctorService } from '../../services/doctor.service';
  import { Shedule } from '../../classes/availableshedule.interface';
  import { MatDialog, MatDialogRef } from '@angular/material';
  import { PopupformComponent } from '../../doctor/popupform/popupform.component';
  import { CommonService } from '../../services/common.service';
  import { Serviceprovider } from '../../classes/serviceprovider.interface';
  import { Leavedays } from '../../classes/leavedays.interface';
  import { Router } from '@angular/router';
  import {MatSnackBar} from '@angular/material';
  import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
  } from '@angular/forms';
  import * as moment from 'moment';
  @Component({
    selector: 'app-docapp',
    templateUrl: './docapp.component.html',
    styleUrls: ['./docapp.component.css'],
  })

  export class DocappComponent implements OnInit {
    ldaysarray = [];
    exploreleavedate: any;
    leavemap: any;
    iflag: number;
    sflag: number;
    lsstatus: number;
    sprovider: Serviceprovider;
    userid: any;
    schedule: Shedule[];
    schedule1: Shedule[];
    leave: Leavedays[]
    selectedDay: any;
    msg: any;
    action: any;
    days = [];
  key: string
  item= [];
  var: any;
  a: string;
  takeleaveflag: number;
  ldays= [];
  sdays = [];
    indexarray = [];
selectedOption: string;
public loading = false;
  // calender
  public date = moment();
  public today: any;
  public dateForm: FormGroup;

  public isReserved = null;

  public daysArr;
  checkarray = [];
  checkallhit : any;
  myregisterclinic: any;
  clinicidstring: any;
    constructor(private doctorservice: DoctorService, public dialog: MatDialog,
      private commonService: CommonService, private router: Router,  public snackBar: MatSnackBar,
      private fb: FormBuilder,  private zone: NgZone) {
        this.days =  ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const udata = this.commonService.getUserDataLocally();
        this.userid = udata.uid;
        this.initDateRange();
        this.takeleaveflag = 0;
        this.lsstatus = 0;
        this.getTime();
      }
      getSchedulelength(da){
        var count = 0;
        for(let i = 0 ; i< this.schedule.length ;i ++) {
          if(this.schedule[i].day == da) {
            count ++;
          }
        }
        return count;
      }
      getTime() {
        this.doctorservice.getTime()
        .subscribe(
          (d) => {
            const ctime = d.date;
            const css = moment(ctime.date).format('YYYY-MM-DD');
            this.today = css;
          });
      }
      public initDateRange() {
        return (this.dateForm = this.fb.group({
          dateFrom: [null, Validators.required],
          dateTo: [null]
        }));
      }
    ngOnInit() {
      this.loading = true;
      this.doctorservice.getServiceproviderownId(this.userid)
      .subscribe(
        (x: Serviceprovider) => {
          this.sprovider = x;
          this.getMyExistingShedule(this.sprovider[0].id);
          this.getMyLeaves(this.sprovider[0].id);
          this.getMyRegisterClinic(this.sprovider[0].id)
        });
        this.daysArr = this.createCalendar(this.date);
    }
    takeLeaveFlag() {
      this.takeleaveflag = 1;
    }
    getMyLeaves(spid) {
      this.doctorservice.getMyLeaves(spid)
      .subscribe(
        (x) => {
          this.leave = x;
          this.ldaysarray = [];
          for ( let i = 0; i < this.leave.length ; i ++) {
            this.getDayOfthisperticulermonth(this.leave[i].date, this.leave[i].id);
          }
        }
      );
    }
    getDayOfthisperticulermonth(dat, i) {
      const da = moment(dat, 'YYYY-MM-DD');
      if (da.month() === this.date.month() && da.year() === this.date.year()) {
        const cda = da.format('YYYY-MM-DD');
        this.ldaysarray.push({'id': i, 'day': cda});
        const daa = da.date();
        this.ldays.push({'id': i, 'day': daa});
        this.lsstatus = this.lsstatus + 1 ;
      }
    }
    getMyExistingShedule(spid) {
      this.doctorservice.getMyExistingShedule(spid)
      .subscribe(
        (b: Shedule[]) => {
          this.loading = false;
          this.schedule = b;
        });
      }
 
  addSchedule(day) {
  this.selectedDay = day;
  this.router.navigate(['/doctor/addschedule/', this.sprovider[0].id, day]);
  }
      editSchedule(id, day, stime, etime, sd) {
        const dialogRef = this.dialog.open(PopupformComponent, {
          width: '500px',
          height: '500px',
          data: {id: id, day: day, stime: stime, etime: etime , sduration: sd}
        } );
        dialogRef.afterClosed().subscribe(result => {
          if (result === 1) {
            this.getMyExistingShedule(this.sprovider[0].id);
            this.msg = 'Schedule Updated Successfully';
          }
        });
      }
      deleteschedule(id) {
        this.loading =true;
        this.doctorservice.deleteSchedule(id)
        .subscribe(
          (x) => {
            this.msg = 'Schedule deleted Successfully'
            for (let i = 0; i < this.schedule.length ; i++ ) {
              if (this.schedule[i].id === id) {
                this.schedule.splice(i , 1);
              }
            }
            this.getMyExistingShedule(this.sprovider[0].id);
            this.showAlert();
          }
        );
      }
      showAlert() {
        this.snackBar.open(this.msg, this.action , {
          duration: 4000,
        });
    }
    public createCalendar(month) {
      const firstDay = moment(month).startOf('M');
      const days = Array.apply(null, { length: month.daysInMonth() })
        .map(Number.call, Number)
        .map(n => {
          return moment(firstDay).add(n, 'd');
        });

      for (let n = 0; n < firstDay.weekday(); n++) {
        days.unshift(null);
      }
      return days;
    }

    public nextMonth() {
      this.ldays = [];
      this.ldaysarray =[];
      this.sdays = [];
      this.leavemap = [];
      this.exploreleavedate = undefined;
      this.date.add(1, 'M');
      this.daysArr = this.createCalendar(this.date);
      this.getMyLeaves(this.sprovider[0].id);
    }

    public previousMonth() {
      this.ldays = [];
      this.ldaysarray = [];
      this.sdays = [];
      this.leavemap = [];
      this.exploreleavedate = undefined;
      this.date.subtract(1, 'M');
      this.daysArr = this.createCalendar(this.date);
      this.getMyLeaves(this.sprovider[0].id);
    }

    public todayCheck(day) {
      if (!day) {
        return false;
      }
      return moment().format('L') === day.format('L');
    }
    public leavedaysCheck(dayy) {
        const dateMoment = moment(dayy, 'MM/DD/YYYY');
        const da = dateMoment.date();
        if (da > 0) {
          for (let i = 0 ; i < this.ldays.length; i++) {
            if (da === this.ldays[i].day) {
              return true;
            }
          }
        }
      }
    checkSelction(){
      if(this.checkarray.length == 0 && this.checkallhit == undefined) {
        this.msg = 'Please Select Clinic';
        this.showAlert();
      }
      else if(this.checkallhit == 'all' && this.checkarray.length == 0){
        this.clinicidstring = this.checkallhit;
      }
      else{
          for(let i = 0; i<this.checkarray.length; i++) {
            if(i == 0){
              this.clinicidstring = this.checkarray[i];
            }
            else{
              this.clinicidstring =  this.clinicidstring + ',' + this.checkarray[i];
            }
        }
        
      }
     this.reserve();
    }
    public reserve() {
      if (this.sdays.length > 0) {
        var count = this.sdays.length;
        this.loading = true;
        const spid = this.sprovider[0].id;
        const  mon = this.date.month() + 1;
        const yar = this.date.year();
        for ( let i = 0 ; i < this.sdays.length ; i++) {
          const ld = yar + '-' + mon + '-' + this.sdays[i] ;
          this.doctorservice.confirmMyLeave(spid, ld, this.clinicidstring)
          .subscribe(
            (x) => {
              count = count - 1;
              if(count == 0){
                this.getMyLeaves(spid);
                this.loading = false;
                 this.msg = 'Leave Confirmed';
              this.showAlert();
                this.sdays = [];
              }
            });
        }
      } else {
        this.msg = 'First Select Days To take Leave';
        this.showAlert();
      }
      }

    public isSelected(day) {
      const dateMoment = moment(day, 'MM/DD/YYYY');
      const da = dateMoment.date();
      if (da > 0) {
        for (let i = 0; i < this.sdays.length; i++) {
          if ( da === this.sdays[i]) {
            return true;
          }
        }
      }
    }
    public selectedDate(day) {
      this.iflag = 0;
      var now = moment();
      const tod = now.date();
      const com = now.month();
      const dateMoment = moment(day, 'MM/DD/YYYY');
      const da = dateMoment.date();
      const mon = dateMoment.month();
      const year = dateMoment.year();
      if (da >= tod && com == mon ) {
        for (let i = 0 ; i < this.ldays.length; i++) {
          if (this.ldays[i].day === da) {
            this.iflag = this.iflag + 1;
          }
        }
        this.insertIntoSdays(da);
      }else if(da != undefined && dateMoment > now) {
        for (let i = 0 ; i < this.ldays.length; i++) {
          if (this.ldays[i].day === da) {
            this.iflag = this.iflag + 1;
          }
        }
        this.insertIntoSdays(da);
      }else {
        this.msg = 'invalid Selection';
        this.showAlert();
      }
     }
     public insertIntoSdays(da) {
        if (this.iflag == 0) {
          this.confirmInsertion(da);
      }else {
        this.msg = 'Already Selected As Leave';
        this.showAlert();
      }
    }
      confirmInsertion(da) {
        if ( this.sdays.length === 0) {
          this.sdays.push(da);
          this.sflag = 2;
        }else  {
          for (let i = 0; i < this.sdays.length; i++) {
            if (this.sdays[i] === da ) {
            this.sflag = 1;
            break;
            } else {
              this.sflag = 0;
            }
          }
          this.actioinInSdays(da)
      }
      }
      actioinInSdays(da) {
        if (this.sflag === 0 ) {
          this.sdays.push(da);
        }
        if (this.sflag === 1 ) {
          for ( let i = 0; i < this.sdays.length ; i++) {
          if (this.sdays[i] === da) {
            this.sdays.splice(i, 1);
          }
          }
      }
      }
      cancellLeave(id, day) {
        this.loading = true;
        this.leavemap = [];
        this.exploreleavedate = undefined;
        this.doctorservice.canecellLeave(id)
        .subscribe(
          (x) => {
            this.loading = false;
            for (let i = 0; i < this.ldays.length; i++) {
              if (this.ldays[i].id === id) {
                this.ldays.splice(i, 1);
                
              }
            }
            for (let j = 0; j < this.ldaysarray.length; j++) {
              if (this.ldaysarray[j].id === id) {
                this.ldaysarray.splice(j, 1);
              }
            }
              this.msg = 'leave Cancelled successfully';
              this.showAlert();
          }
        )
      }
      getMyRegisterClinic(spid){
        console.log('spid', spid);
        this.loading = true;
        this.doctorservice.getMyRegisterClinic(spid)
        .subscribe(
          (x)=>{
            this.myregisterclinic = x;
            console.log(this.myregisterclinic);
          });
      }
      

      addClicnicid(e, data) {
          if (e.target.checked) {
             this.checkarray.push(data);
          }
          if ( !e.target.checked) {
              for ( let i = 0 ; i < this.checkarray.length; i++) {
               if ( this.checkarray[i] === data ) {
               this.checkarray.splice(i , 1);
                }
              }
          }
      }
      setCheckhit(e){
       
        if (e.target.checked) {
          this.checkarray = [];
          this.clinicidstring = undefined;
          this.checkallhit = 'all';
        }
        if ( !e.target.checked) {
          this.checkallhit = undefined;
          this.clinicidstring = undefined;
       }
      }
      isAllChecked(){
        if(this.checkallhit == 'all'){
          return true;
        }
      }
      exploreLeave(lid,ldate){
        this.loading = true;
        this.exploreleavedate = ldate;
        this.leavemap = [];
        this.doctorservice.getMyLeavemapping(lid)
        .subscribe(
          (x)=>{
            this.leavemap = x;
            this.loading = false;
          });
      }
      isLeaveMapped(id){
        if(this.leavemap.length == 1){
          if(this.leavemap == 'all'){
            return true;
          }
          else{
            for(let i= 0 ;i<this.leavemap.length ; i ++) {
              if(this.leavemap[i] == id){
                return true;
              }
            }
          }
        }
        else {
          for(let i= 0 ;i<this.leavemap.length ; i ++) {
            if(this.leavemap[i] == id){
              return true;
            }
          }
        }
      }
    }
